import { render, staticRenderFns } from "./OverdueRenderer.vue?vue&type=template&id=173c3b69&"
import script from "./OverdueRenderer.vue?vue&type=script&lang=js&"
export * from "./OverdueRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports